<template>
    <div>
        <breadcrumb v-if="a == 1" :routerList="[{to:'/yuce/wxyuceReport',title:'外销报表'},{title:'预测占用详情'}]"/>
        <breadcrumb v-if="a == 2" :routerList="[{to:'/yuce/wxycWeekReport',title:'外销周报表'},{title:'预测占用详情'}]"/>
        <div class="h-content">
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <div class="h-pieceIn2" style="padding-left:0.26rem;">
                        <div class="h-pieceTitle2"
                             style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                            <h1>被占用信息</h1>
                        </div>
                    </div>
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
							border
                            :span-method="objectSpanMethod"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="orderId"
								width="130"
                                label="占用订单号"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="operateId"
								width="160"
                                label="占用预测号"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proModel"
                                label="占用产品型号"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
										<div style="text-align: left;">{{scope.row.proModel}}</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                label="占用产品编码"
								width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="useNum"
								width="90"
                                label="占用数量"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
								width="110"
                                label="占用人名称"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                label="占用时间"
								width="160"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <div class="h-pieceIn2" style="padding-left:0.26rem;">
                        <div class="h-pieceTitle2"
                             style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                            <h1>占用预测信息</h1>
                        </div>
                    </div>
                    <el-table
                            ref="multipleTable"
                            :data="tableData2"
                            stripe
                            border
                            :span-method="objectSpanMethod2"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="forecastId"
                                width="130"
                                label="占用的预测号"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proModel"
                                label="占用产品型号"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">{{scope.row.proModel}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                label="占用产品编码"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="useNum"
                                width="90"
                                label="占用数量"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                width="110"
                                label="占用人名称"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                label="占用时间"
                                width="160"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="renovate">返回</el-button>
            </div>
        </div>
    </div>
</template>
<script>

    import ss from '../../../api/SystemService';

    export default {
        data() {
            return {
                tableData: [],
                tableData2: [],
                spanArr: [],
                spanArr2: [],
                a: '',
                position: '',
                position2: '',
            }
        },
        mounted() {

        },
        created() {
            this.a = this.$route.query.status
            this.query();
        },
        beforeRouteLeave(to,from,next){
            if((to.path=='/yuce/wxyuceReport' || to.path=='/yuce/wxyuceReport-goods'
                || to.path=='/yuce/wxyuceReport-public' || to.path=='/yuce/wxycWeekReport'
                || to.path=='/yuce/wxyuceReport-summary' || to.path=='/yuce/wxyuceReport-inventory' || to.path=='/yuce/wxyuceReport-ycd')
                && from.path == '/yuce/yuceOccupy'){
                to.meta.keepAlive = true;
            }else{
                to.meta.keepAlive = false;
            }
            next();
        },
        methods: {
            getSpanArr() {
                this.spanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].proCode === this.tableData[index - 1].proCode) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            getSpanArr2() {
                this.spanArr2 = [];
                this.tableData2.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr2.push(1);
                        this.position2 = 0;
                    } else {
                        if (this.tableData2[index].proCode === this.tableData2[index - 1].proCode) {
                            this.spanArr2[this.position2] += 1;
                            this.spanArr2.push(0);
                        } else {
                            this.spanArr2.push(1);
                            this.position2 = index;
                        }
                    }
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (column.label == '占用产品型号' || column.label == '占用产品编码') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },
            objectSpanMethod2({row, column, rowIndex, columnIndex}) {
                if (column.label == '占用产品型号' || column.label == '占用产品编码') {
                    const _row = this.spanArr2[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },

            query() {
                var v = this.$route.query.id;
                ss.waixiao.showOccupy(v).then(rd => {
                    this.tableData = rd.bzy;
                    this.tableData2 = rd.zy;

                    this.getSpanArr();
                    this.getSpanArr2();
                })
            },
            renovate() {
                this.$router.go(-1);
            },
        }
    }
</script>